import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e71de5e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-start gap-4 mb-6 p-6 pb-0" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "flex-col items-center text-secondary50 justify-between w-full" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-3 justify-between"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["d"]
const _hoisted_10 = { class: "text-2xl font-bold text-left" }
const _hoisted_11 = ["d"]
const _hoisted_12 = {
  key: 1,
  class: "text-md text-left mt-4"
}
const _hoisted_13 = { class: "flex-1 overflow-y-auto px-6 scrollbar-gutter-stable" }
const _hoisted_14 = {
  key: 0,
  class: "md:hidden pb-3"
}
const _hoisted_15 = {
  key: 0,
  class: "p-6 pt-0"
}

import { mdiArrowRight } from '@mdi/js'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSidebar',
  props: {
    modelValue: { type: Boolean },
    title: {},
    description: {},
    icon: {},
    iconRight: {},
    sizeIcon: { type: Boolean },
    headerChildren: {},
    isIconRightActive: { type: Boolean },
    backdrop: { type: Boolean, default: true },
    backgroundColor: { default: '#E2E2E9' },
    width: { default: '450px' }
  },
  emits: ["update:modelValue", "openFilter"],
  setup(__props: any, { emit }) {

const props = __props;





const isHovering = ref(false)

function closeSidebar() {
  emit('update:modelValue', false)
}

function handleIconRightClick() {
  emit('openFilter')
}

const iconRightClasses = computed(() => ({
  'bg-[#2F7F91] text-white': props.isIconRightActive || isHovering.value,
  'bg-white text-[#2F7F91]': !props.isIconRightActive && !isHovering.value
}))

const iconFillColor = computed(() => {
  return '#000'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "overlay-fade" }, {
      default: _withCtx(() => [
        (_ctx.modelValue && _ctx.backdrop)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed z-40 inset-0 bg-black/20",
              onClick: closeSidebar
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "sidebar-slide" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-testid": "sidebar-panel",
              class: "fixed z-50 top-0 right-0 bottom-0 w-screen md:w-[var(--sidebar-width)] h-full shadow-xl flex flex-col",
              style: _normalizeStyle({ backgroundColor: props.backgroundColor, '--sidebar-width': props.width })
            }, [
              _renderSlot(_ctx.$slots, "header", { close: closeSidebar }, () => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("button", {
                    "data-testid": "sidebar-close-button",
                    onClick: closeSidebar,
                    class: "text-textPrimary hover:text-textPrimary/50 transition mt-1"
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                      _createElementVNode("path", { d: _unref(mdiArrowRight) }, null, 8, _hoisted_3)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.title)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_ctx.headerChildren)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                innerHTML: _ctx.headerChildren
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, [
                            (_ctx.icon)
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 0,
                                  class: _normalizeClass([props.sizeIcon && 'w-8 h-8', "w-6 h-6 shrink-0"]),
                                  fill: iconFillColor.value,
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", { d: _ctx.icon }, null, 8, _hoisted_9)
                                ], 10, _hoisted_8))
                              : _createCommentVNode("", true),
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.title), 1)
                          ]),
                          (_ctx.iconRight)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: handleIconRightClick,
                                onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHovering.value = true)),
                                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovering.value = false)),
                                class: _normalizeClass(["w-10 h-10 flex items-center justify-center text-end rounded-full border-2 border-[#2F7F91] transition-all cursor-pointer", iconRightClasses.value])
                              }, [
                                (_openBlock(), _createElementBlock("svg", {
                                  class: _normalizeClass(props.sizeIcon ? 'w-5 h-5' : 'w-4 h-4'),
                                  fill: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    d: props.iconRight
                                  }, null, 8, _hoisted_11)
                                ], 2))
                              ], 34))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("hr", {
                    class: _normalizeClass(["w-full border-t border-[#2F7F91]/25", props.iconRight && '!border-t-[3px] !border-[#2F7F91]'])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.$slots.contextHeader)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _renderSlot(_ctx.$slots, "contextHeader")
                    ]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ]),
              (_ctx.$slots.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _renderSlot(_ctx.$slots, "footer")
                  ]))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})